import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Moment } from 'moment';
import * as moment from "jalali-moment";
import { environment } from 'src/environments/environment';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatCalendarCellCssClasses, MatCalendar } from '@angular/material';
import { LogCalendarEventComponent } from '../log-calendar-event/log-calendar-event.component';
import { CalendarService } from 'src/app/services/http/business/calendar/calendar.service';
import { CompanyService } from 'src/app/services/http/business/company/company.service';
import { CIDService } from 'src/app/services/common/cid.service';

@Component({
  selector: 'app-calender-management',
  templateUrl: './calender-management.component.html',
  styleUrls: ['./calender-management.component.css']
})
export class CalenderManagementComponent implements OnInit {
  form: FormGroup;
  dates = [];
  holidays = [];
  filter: any = {
    holidayTypeId: null,
    companyId: null,
    date: null
  };

  holidayList: any;
  company: any;
  dateFilter: () => any;
  holidayType: any = {};
  // @ViewChild("input") input: ElementRef<HTMLInputElement>;
  @ViewChild('calendar') calendar: MatCalendar<Moment>;
  selectedDate: Moment;
  constructor(
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private fb: FormBuilder,
    private cidService: CIDService,
    private dialog: MatDialog,
    private calendarService: CalendarService,
  ) { }

  ngOnInit() {
    //let today = moment();

    this.route.paramMap.subscribe(params => {
      this.filter.companyId = params["params"].companyId;
      this.getMonthDateRange(moment());
    });
    this.createForm();
    this.getHolidayTypeList();
    this.getCompany();
    // this.getList();
  }

  getMonthDateRange(date: any) {

    this.filter.date = moment.from(date, "fa").utc(true).format(environment.dateFaFormat);
    // let getYear: any = moment.from(date, "en").utc(true).format("YYYY");
    // let getMonth: any = moment.from(date, "en").utc(true).format("M");
    // var firstDay: any = new Date(getYear, getMonth - 1, 1);
    // const lastDay: any = new Date(getYear, getMonth, 0);
    // this.filter.startDate = moment.from(firstDay, "en").utc(true).format(environment.dateFormat);
    // this.filter.endDate = moment.from(lastDay, "en").utc(true).format(environment.dateFormat);

  }
  monthSelected(date: any) {
    //console.log('monthSelected');
    alert(`Selected: ${date}`);
    this.getMonthDateRange(date);
    this.filterByHolidayType();
    //this.filter.date = date;
    // this.getList();
  }

  createForm() {
    this.form = this.fb.group({
      DailyDate: [null],
    });

  }

  getCompany() {
    this.cidService.setCID(this.filter.companyId);
    this.companyService.companyById().subscribe(res => {
      console.log(res);
      this.company = res;
    })
  }

  getHolidayTypeList() {
    this.calendarService.calendarHolidayList().subscribe(res => {
      this.holidayList = res.DataList;
      this.filter.holidayTypeId = this.holidayList[0].Id;
      this.filterByHolidayType();
    });
  }

  filterByHolidayType() {
    this.getList();

  }

  getList() {

    this.holidayType = this.holidayList.find(x => x.Id == this.filter.holidayTypeId);
    const queryParams = {
      calendarHolidayId: this.filter.holidayTypeId,
      date: this.filter.date
    }

    this.calendarService.calendarHolidayListByCurentDate(queryParams).subscribe(res => {

      this.dates = res;
      //this.calendar.updateTodaysDate();
      //this.holidays
      // if (this.dates.length>0) {

      this.holidays = this.dates.map((item) => {
        return {
          datePersian: item.DatePersian,
          dailyDate: item.DailyDate,
          explain: item.CalendarHolidayList[0].Explain,
        }
      });
      this.dateFilter = (): any => {
        //console.log('dateFilter');

        return (dateParams): MatCalendarCellCssClasses => {
          //console.log(dateParams);
          let data = moment.from(dateParams, "en").utc(true).format("YYYY-MM-DDTHH:mm:ss");
          let temp = this.dates.find(x => x.DailyDate == data);
          //this.filter.date = moment.from(dateParams, "fa").utc(true).format(environment.dateFaFormat);
          //this.getList();
          return temp ? 'td-Calender' : '';
        }
      };
      this.calendar.updateTodaysDate();
      // } else {
      //     this.holidays=[];
      // }

    });
  }
  // test(){
  //
  //   this.dateFilter = (): any => {
  //     return (dateParams): MatCalendarCellCssClasses => {
  //       let data = moment.from(dateParams, "en").utc(true).format("YYYY-MM-DDTHH:mm:ss");
  //       let temp = this.dates.find(x => x.DailyDate == data);
  //       return temp ? 'td-Calender' : '';
  //     }
  //   };
  // }
  onSelectDate(event) {
    console.log('onSelectDate');

    this.getMonthDateRange(event);
    let date = moment
      .from(event, "en")
      .utc(true)
      .format(environment.dateFormat);
    this.form.controls['DailyDate'].setValue(date);
    const changeFormatFromEdit = moment.from(event, "en").utc(true).format("YYYY-MM-DDTHH:mm:ss");
    let edit = this.holidays.find(x => x.dailyDate == changeFormatFromEdit);

    this.dialog
      .open(LogCalendarEventComponent, {
        width: "350px",
        data: {
          HolidayTypeId: this.filter.holidayTypeId,
          dailyDate: this.form.value.DailyDate,
          companyId: this.filter.companyId,
          Explain: edit ? edit.explain : null,
          isUpdate: edit ? true : false
        },
        disableClose: true
      })
      .afterClosed()
      .subscribe(() => {

        this.form.controls['DailyDate'].setValue(null);
        this.filterByHolidayType();
      });
  }
  // this.dateFilter = (): any => {
  //   return (dateParams): MatCalendarCellCssClasses => {
  //
  //     let data = momentJalali.from(dateParams, "en").utc(true).format("YYYY-MM-DDTHH:mm:ss");
  //     let arry = [];
  //     arry = this.reservationDateList;
  //     let temp = arry.find(x => x.Date == data);
  //     return !temp ? 'disabled' : '';
  //   }
  // };
}
